import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Guid } from 'guid-typescript';
import { ClientURL, ClientURLResponse } from '../../../models/clienturl.model';
import { ContractRemoteService } from '../../../services/contractRemote.service';
import { UtilityService } from '../../../services/shared/utility.service';

//For jquery
declare var $: any;

@Component({
    selector: 'app-connect-client',
    templateUrl: './connect-client.component.html',
    styleUrls: ['./connect-client.component.css']
})
/** connectClient component*/
export class ConnectClientComponent implements OnInit{
    clientURLResponse: ClientURLResponse;
    clientURL: ClientURL;
    urlID: any;
    /** connectClient ctor */
    constructor(private _router: Router,
        private _route: ActivatedRoute,
        private _contactRemoteService: ContractRemoteService,
        private _utilityService: UtilityService) {

        
    }

    ngOnInit(): void {
        this._route.paramMap.subscribe(async params => {
            //debugger;
            if (params.has('urlid')) {
                console.log(params.get('urlid'));
                this.urlID =params.get('urlid');
               
            }
        })
        
        this.getClientUrl();
    }

    private async getClientUrl() {

        await this._contactRemoteService.getclientUrlAsync("", this.urlID)
            .then(async (result: ClientURLResponse) => {
               
                if (result) {
                    if (result.statusCode == 0) {
                        this.clientURLResponse = UtilityService.clone(result);
                        if (this.clientURLResponse) {                           
                            $(location).attr('href', this.clientURLResponse.clientURL.clientURL);
                            
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }
}
